module.exports = __webpack_public_path__ + "img/IMG_7073.9e1db934.webp";